import type { SiteControllerSettingBeds24MasterDataSyncInput } from "@/lib/gql/__generated__/graphql";

import type { SiteControllerSettingBeds24FormModel } from "../../../../type";

type Props = {
	viewModel: Pick<
		SiteControllerSettingBeds24FormModel["ViewModel"],
		"hotelID" | "beds24AuthenticationApiKey" | "beds24AuthenticationPropKey"
	>;
};
export const viewModelToInput = ({
	viewModel: { hotelID, beds24AuthenticationApiKey, beds24AuthenticationPropKey },
}: Props) => {
	const input: SiteControllerSettingBeds24MasterDataSyncInput = {
		hotelID,
		beds24AuthenticationApiKey: beds24AuthenticationApiKey?.value,
		beds24AuthenticationPropKey: beds24AuthenticationPropKey.value,
	} satisfies SiteControllerSettingBeds24MasterDataSyncInput;

	return input;
};
